import { createContext, useContext } from 'react';

type OverlayTriggerContextType = {
    handleShow: () => void;
    handleHide: () => void;
    handleHideIfTriggeredByHover: () => void;
    shouldTriggerOnHover: boolean;
    setInteractable: (value: boolean) => void;
};

export const OverlayTriggerContext = createContext<OverlayTriggerContextType | null>(null);

export const useOverlayTriggerContext = () => useContext(OverlayTriggerContext);
